import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgControl, ReactiveFormsModule } from '@angular/forms';
import { Route } from '@angular/router';
import { AppTemplateModule } from '../app-template/app-template.module';
import { AppMenuItem } from '../app-template/models/app-menu-item.model';
import { AppTab } from '../app-template/models/app-tab.model';
import { PrimeModule } from '../prime/prime.module';
import { AdminPageDefinition } from '../sm-base/models/admin-page-definition.model';
import { FeatureModule } from '../sm-base/models/feature.module';
import { FeatureModuleService } from '../sm-base/services/feature-module.service';
import { SmBaseModule } from '../sm-base/sm-base.module';
import { Objects } from "../utils/shared/objects";
import { RungisSupplierComponent } from './components/supplier-form/rungis-supplier.component';
import { RungisSupplierRoutingModule } from './rungis-supplier-routing.module';

@NgModule({
    declarations: [
        RungisSupplierComponent
    ],
    imports: [
        AppTemplateModule,
        CommonModule,
        PrimeModule,
        SmBaseModule,
        ReactiveFormsModule
    ],
    providers: [{ provide: NgControl, useValue: NgControl }]
})
export class RungisSupplierModule implements FeatureModule {

    constructor(private featureModuleService: FeatureModuleService) {
        featureModuleService.register(this);
    }

    getId(): string {
        return "RungisSupplierModule";
    }
    
    registerSidebar(model: AppTab[]): void {
        model.push(new AppTab("supplier", "Lieferant", "", 100, [
            Objects.fromPlain(AppMenuItem, { sort: 170, label: "Lieferant", icon: "", routerLink: ["/rungis-supplier", "home"] })
        ]));
    }

    async updateSidebarVisibility(_: AppTab[]): Promise<void> {
    }

    getMainRoute(): Route {
        return this.featureModuleService.createModuleRoute("rungis-supplier", () => RungisSupplierRoutingModule);
    }

    async beforeAppStart(): Promise<void> {
    }

    getAdminPages(): AdminPageDefinition[] {
        return [];
    }
}